export const SEND_METHOD_TYPES = {
  EMAIL: 1,
  MAIL: 2,
  SMS: 3,
};
